<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center" v-if="administrador === true">
          <basic-toolbar :title="'Lista de projetos que possuem parceiros'"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
            :headers="headers"
            :items="listaParcerias"
            :search="search"
            :no-data-text="'Nenhuma parceria encontrada'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.tituloProjeto="props">
                <router-link :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{ props.item.tituloProjeto }}</router-link>
              </template>
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaParcerias.length }} parcerias
              </template>
            </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      listaParcerias: [],
      search: null,
      sortBy: 'idProjeto',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'idProjeto' },
        { text: 'Título', align: 'center', value: 'tituloProjeto' },
        { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' },
        { text: 'Nome do parceiro institucional/colaborador', align: 'center', value: 'nomeParceiro' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      pesquisar () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' })
        projetos.getParcerias()
        .then(response => {
          this.listaParcerias = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaParcerias = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' })
        })
      }
    },
    mounted () {
      this.pesquisar()
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>



// WEBPACK FOOTER //
// parcerias-tabela.vue?0f815467